module.exports = __webpack_public_path__ + "media/images/user-873a7712569b5f1269eecbf1ee78650d.svg";